import React from 'react';

/**
 * UHC "U" brand mark — inline SVG (no external CDN dependency).
 * Source: Official UHC brand mark (uhc-u_mark-blue).
 *
 * @param size   — width & height in px (default 44)
 * @param className — optional CSS class
 */
interface UhcLogoProps {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

const UhcLogo: React.FC<UhcLogoProps> = ({ size = 44, className, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 38 66"
    width={size}
    height={size}
    className={className}
    style={style}
    role="img"
    aria-label="UHC"
  >
    <path
      fill="#002677"
      d="M10.57,62.92h0A20.47,20.47,0,0,0,17.22,64c10,0,17-7.26,17-21V1.87L38,.06V43.69c0,14.06-7.25,22.25-17.53,22.25A18.1,18.1,0,0,1,10.57,62.92ZM6.23,58.74h0A21.79,21.79,0,0,0,12.88,60c8.41,0,14-5.28,14-17.2V5l3.74-1.76V43.14C30.63,55.61,24.31,62,15.52,62A15.84,15.84,0,0,1,6.23,58.74ZM3.6,55h0a20.24,20.24,0,0,0,5.55,1c6.53,0,10.54-3.58,10.54-13V8.19l3.69-1.76V42.48c0,10.55-4.84,15.33-11.76,15.33A13.08,13.08,0,0,1,3.6,55ZM16.23,44V9.62L0,16.93V44.84c0,5.33,3.36,8.9,8.3,8.9S16.23,50.12,16.23,44Z"
    />
  </svg>
);

export default UhcLogo;
